const FAQ_HEADING = /soalan (lazim|popular)|faq/i;

// Ambil pasangan soalan/jawapan (h3 + p) di bawah heading "Soalan Lazim" / "FAQ" dalam HTML blog
export function extractFaq(html) {
  if (!html || typeof DOMParser === 'undefined') return [];
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const heading = [...doc.querySelectorAll('h2')].find(h => FAQ_HEADING.test(h.textContent));
  if (!heading) return [];
  const faqs = [];
  let current = null;
  for (let el = heading.nextElementSibling; el && el.tagName !== 'H2'; el = el.nextElementSibling) {
    if (el.tagName === 'H3') {
      current = { q: el.textContent.trim(), a: '' };
      faqs.push(current);
    } else if (current && el.tagName === 'P') {
      current.a = `${current.a} ${el.textContent.trim()}`.trim();
    }
  }
  return faqs.filter(f => f.q && f.a);
}

export const faqJsonLd = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(f => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })),
});
